<div class="next-banner"
     [class]="banner.cssClassSuffix ? 'next-banner next-banner--' + banner.cssClassSuffix : 'next-banner'"
    [ngClass]="{'next-banner--aztec-scanner': aztecScannerBannerVisible}">
  <div class="next-banner__content main">
    <ng-container *ngIf="aztecScannerBannerVisible; else standardBanner">
      <ng-template *ngTemplateOutlet="aztecScannerBanner"></ng-template>
    </ng-container>
  </div>
</div>

<ng-template #standardBanner>
  <div class="next-banner__text">
    <h1 class="next-banner__text__title">
      {{ banner.title | translate }}
    </h1>
    <p class="next-banner__text__subtitle">
      {{ banner.subtitle | translate }}
    </p>
  </div>

  <div class="next-banner__image">
    <img [src]="banner.imageSrc"
         alt="">
  </div>
</ng-template>

<ng-template #aztecScannerBanner>
  <div class="next-banner__text">
    <div class="next-banner__text__title">
      {{ 'AZTEC_SCANNER_BANNER.TITLE' | translate }}
    </div>
    <div class="next-banner__text__subtitle"
        [innerHTML]="'AZTEC_SCANNER_BANNER.SUBTITLE' | translate | safeHtml">
    </div>
    <div class="next-banner__text__button">
      <button (click)="scan()"
              class="btn btn--secondary btn--big btn--no-outline">
        {{ 'AZTEC_SCANNER_BANNER.BUTTON' | translate }}
      </button>
    </div>
  </div>
  <div class="next-banner__image">
    <img [src]="aztecScannerImageSrc"
         alt="">
  </div>
</ng-template>
